import * as React from 'react';

import { Checkbox, cn } from '@rematter/ui-web';

import { AddToSalesOrderButtonCellProps } from '../types';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { LoadFormLineItem } from '~/modules/trade/types/load';

export interface ExtendedAddToSalesOrderButtonCellProps extends Omit<
  AddToSalesOrderButtonCellProps,
  'onAddLineItem'
> {
  onUpdateLineItem: (id: string, updates: Partial<LoadFormLineItem>) => void;
}

export const AddToSalesOrderButtonCell: React.FC<
  ExtendedAddToSalesOrderButtonCellProps
> = ({ disabled = false, lineItem, onUpdateLineItem }) => {
  const t = useTranslations();
  const handlePress = React.useCallback(() => {
    onUpdateLineItem(lineItem.id, {
      includeInSalesOrder: !lineItem.includeInSalesOrder,
    });
  }, [lineItem.id, onUpdateLineItem, lineItem.includeInSalesOrder]);

  return (
    <div
      className={cn(
        '@AddToSalesOrderButtonCell',
        'flex max-h-10 items-center justify-center rounded-md border border-neutral/20 bg-neutral/5 px-2 py-3',
      )}
    >
      <Checkbox
        isDisabled={disabled}
        isSelected={lineItem.includeInSalesOrder}
        onChange={handlePress}
      >
        <span>{t.itemTable.standaloneLoad.addToSalesOrderButton}</span>
      </Checkbox>
    </div>
  );
};
